
import { defineComponent, nextTick, onMounted, reactive, toRefs } from "vue";
import { stateType } from "./baseManageState";
import {
  getSourceDetail,
  getTrailData,
  delTrailData,
  getFarmerLandList,
  deleteFarmerLand,
  getFarmerFarmingList,
  delFarmingData,
  getFarmingTaskData,
  igonreFarming,
  getLandFilterData,
} from "../../../api/farmer";
import { useRoute, useRouter } from "vue-router";
import { Toast, Dialog } from "vant";
import Throttle from "@/utils/throttle";
import { dateFormat, getDuration } from "@/utils/util";
import FarmingTask from "@/components/farmingTask/farmingTask.vue";
import store from "@/store/index";
const stateData = {
  dataObj: {},
  sourceId: "",
  avatar: require("../../assets/icons/farmer.png"),
  active: "0",
  trailPage: 1,
  trailDataList: [],
  landPage: 1,
  landList: [],
  farmingLand: "-1",
  farmingLandList: [],
  endValue: new Date(),
  startValue: new Date(),
  selectedStartDate: "",
  selectedEndDate: "",
  statusList: [
    { value: -1, text: "全部" },
    { value: 0, text: "未操作" },
    { value: 1, text: "已完成" },
    { value: 2, text: "已忽略" },
  ],
  selectedTaskStatus: 0,
  selectedTaskLand: "-1",
  recordPage: 1,
  farmingRecordList: [],
  taskPage: 1,
  taskStatus: 0,
  taskList: [],
  lat: 0,
  lng: 0,
};
let task: any, trail: any, land: any, record: any;
export default defineComponent({
  components: {
    FarmingTask,
  },
  setup() {
    const states = reactive<stateType>(stateData);
    const route = useRoute();
    const router = useRouter();
    const {
      getSourceInfo,
      getTrailDataList,
      getFarmerLandDataList,
      getFarmingRecords,
      getTaskDataList,
      getLandFilterList,
    } = useData(states);
    onMounted(() => {
      states.sourceId = route.params.sourceId as string;
      nextTick(() => {
        states.landList = [];
        states.landPage = 1;
        states.farmingRecordList = [];
        states.recordPage = 1;
        states.taskPage = 1;
        states.taskList = [];
        states.trailPage = 1;
        states.trailDataList = [];
        getTrailDataList();
        getFarmerLandDataList();
        getFarmingRecords();
        getLandFilterList();
        //执行方法
        getSourceInfo({
          id: states.sourceId,
          lng: store.state.lngLat.lng,
          lat: store.state.lngLat.lat,
        });
        trail = new Throttle(500, () => {
          states.trailPage++;
          getTrailDataList();
        });
        land = new Throttle(500, () => {
          states.landPage++;
          getFarmerLandDataList();
        });
        task = new Throttle(500, () => {
          states.taskPage++;
          getTaskDataList();
        });
        record = new Throttle(500, () => {
          states.recordPage++;
          getFarmingRecords();
        });
      });
    });
    return {
      ...toRefs(states),
      getDuration,
      ...useEvent(states, router),
    };
  },
});
const useData = (state: stateType) => {
  const getLandFilterList = async () => {
    const result: any = await getLandFilterData({ sourceId: state.sourceId });
    if (result.data.code == 0) {
      state.farmingLandList = result.data.data.map((item: any) => {
        const obj = { text: item.code, value: item.id };
        return obj;
      });
      state.farmingLandList.unshift({ text: "全部地块", value: "-1" });
    }
  };
  const getTaskDataList = async () => {
    const result: any = await getFarmingTaskData({
      page: state.taskPage,
      pageSize: 10,
      status: state.taskStatus == -1 ? "" : state.taskStatus,
      areaId: state.selectedTaskLand == "-1" ? "" : state.selectedTaskLand,
      farmerId: state.dataObj.farmerId,
      sourceId: state.sourceId,
    });
    if (result.data.code == 0) {
      state.taskList = state.taskList.concat(result.data.data.records);
    }
  };
  const getFarmingRecords = async () => {
    const areaId = state.farmingLand == "-1" ? "" : state.farmingLand;
    let times = "";
    if (state.selectedStartDate && state.selectedEndDate) {
      times = state.selectedStartDate + " - " + state.selectedEndDate;
    }
    const result: any = await getFarmerFarmingList({
      page: state.recordPage,
      pageSize: 10,
      sourceId: state.sourceId,
      areaId,
      times,
    });
    if (result.data.code == 0) {
      const tempList = result.data.data.records.map((item: any) => {
        item.imgList = item.img ? item.img.split(",") : [];
        item.videoList = item.video ? item.video.split(",") : [];
        return item;
      });
      state.farmingRecordList = state.farmingRecordList.concat(tempList);
    }
  };
  const getFarmerLandDataList = async () => {
    const result: any = await getFarmerLandList({
      page: state.landPage,
      pageSize: 10,
      sourceId: state.sourceId,
    });
    if (result.data.code == 0) {
      state.landList = state.landList.concat(result.data.data.records);
    }
  };
  const deleteTrailData = async (id: string) => {
    const result: any = await delTrailData({ id: id });
    if (result.data.code == 0) {
      Toast.success("已删除");
      state.trailPage = 1;
      state.trailDataList = [];
      getTrailDataList();
    }
  };
  const getTrailDataList = async () => {
    const result: any = await getTrailData({
      page: state.trailPage,
      pageSize: 10,
      sourceId: state.sourceId,
    });
    if (result.data.code == 0) {
      state.trailDataList = state.trailDataList.concat(
        result.data.data.records
      );
    }
  };
  const getSourceInfo = async (params: any) => {
    const result: any = await getSourceDetail(params);
    if (result.data.code == 0) {
      state.dataObj = result.data.data;
      getTaskDataList();
    }
  };
  return {
    getSourceInfo,
    getTrailDataList,
    deleteTrailData,
    getFarmerLandDataList,
    getTaskDataList,
    getFarmingRecords,
    getLandFilterList,
  };
};
//
const useEvent = (state: stateType, router?: any) => {
  const { deleteTrailData, getFarmingRecords, getTaskDataList } =
    useData(state);
  const toResource = () => {
    router.push({ path: "/addResource", query: { id: state.dataObj.id } });
  };
  const onCall = () => {
    if (state.dataObj.farmerInfo.phoneNumber) {
      const a = document.createElement("a");
      a.href = "tel:" + state.dataObj.farmerInfo.phoneNumber;
      let body: any = document.getElementsByTagName("body")[0];
      body.appendChild(a);
      a.click();
      body.remove;
    } else {
      Toast.fail("无法获取号码");
    }
  };
  const onTaskLandChange = (e: any) => {
    state.selectedTaskLand = e;
    state.taskPage = 1;
    state.taskList = [];
    getTaskDataList();
  };
  const onTaskStatusChange = (e: any) => {
    state.taskStatus = e == -1 ? "" : e;
    state.taskPage = 1;
    state.taskList = [];
    getTaskDataList();
  };
  const onShowDetail = (e: any) => {
    router && router.push("/farmingDetail/" + e.id);
  };
  const onRecord = (e: any) => {
    router &&
      router.push({
        path: "/farmingRecord",
        query: {
          typeId: e.farmingType,
          typeName: e.farmingTypeName,
          name: e.plantFarmingName,
        },
      });
  };
  const onIgnore = (e: any) => {
    Dialog.confirm({ title: "标题", message: "是否忽略该任务？" }).then(() => {
      igonreFarming({
        id: e.id,
      }).then((res: any) => {
        if (res.data.code == 0) {
          Toast({
            message: "已忽略",
          });
          const { getTaskDataList } = useData(state);
          state.taskPage = 1;
          state.taskList = [];
          getTaskDataList();
        }
      });
    });
  };
  const onDelFarming = (item: any) => {
    Dialog.alert({
      title: "提示",
      message: "确定删除该数据？",
      showCancelButton: true,
    }).then(async () => {
      const result: any = await delFarmingData({ id: item.id });
      if (result.data.code == 0) {
        Toast.success("已删除");
        state.recordPage = 1;
        state.farmingRecordList = [];
        getFarmingRecords();
      }
    });
  };
  const onEditFarming = (item: any) => {
    // 在这个记录的数据里面没有status和recordId 这个记录数据的id就是recordId
    // 所以为了和农事任务那边的情况保持一致，这里手动添加两个属性，跳转之后编辑页面会用到。否则编辑页面会根据这个情况写两套逻辑
    //实属无奈
    item.optionRecordId = item.id;
    item.status = 1;
    router.push({
      path: "/updateFarming",
      query: {
        item: JSON.stringify(item),
      },
    });
  };
  const onClickAddRecord = () => {
    router.push({
      path: "/updateFarming",
      query: {
        sourceId: state.sourceId,
      },
    });
  };
  const onLandChange = (e: any) => {
    state.farmingLand = e;
    state.recordPage = 1;
    state.farmingRecordList = [];
    getFarmingRecords();
  };
  const onClickImage = () => {
    router.push({
      path: "/showImage",
      query: {
        imgList: JSON.stringify(state.dataObj.images),
      },
    });
  };
  const onClickVideo = () => {
    router.push({
      path: "/showVideo",
      query: {
        videoList: JSON.stringify(state.dataObj.videos),
      },
    });
  };
  const onStartChange = (e: any) => {
    state.selectedStartDate =
      dateFormat(e).YYYY + "-" + dateFormat(e).MM + "-" + dateFormat(e).DD;
    if (state.selectedStartDate && state.selectedEndDate) {
      // 当开始时间比结束时间大的时候， 就将结束时间调整为和开始时间一样，同一天
      if (
        new Date(state.selectedStartDate).getTime() >
        new Date(state.selectedEndDate).getTime()
      ) {
        state.selectedEndDate = state.selectedStartDate;
      }
      state.recordPage = 1;
      state.farmingRecordList = [];
      getFarmingRecords();
    }
  };
  const onEndChange = (e: any) => {
    state.selectedEndDate =
      dateFormat(e).YYYY + "-" + dateFormat(e).MM + "-" + dateFormat(e).DD;
    if (state.selectedStartDate && state.selectedEndDate) {
      // 当开始时间比结束时间大的时候， 就将结束时间调整为和开始时间一样，同一天
      if (
        new Date(state.selectedStartDate).getTime() >
        new Date(state.selectedEndDate).getTime()
      ) {
        state.selectedEndDate = state.selectedStartDate;
      }
      state.recordPage = 1;
      state.farmingRecordList = [];
      getFarmingRecords();
    }
  };
  const onDeleteLand = (item: any) => {
    Dialog.alert({
      title: "提示",
      message: "确定删除该数据？",
      showCancelButton: true,
    }).then(async () => {
      const result: any = await deleteFarmerLand(item.id);
      if (result.data.code == 0) {
        Toast.success("已删除");
        const { getFarmerLandDataList } = useData(state);
        state.landPage = 1;
        state.landList = [];
        getFarmerLandDataList();
      }
    });
  };
  const onEditLand = (item: any) => {
    router.push({
      path: "/baseManage/operationLand",
      query: {
        typeId: state.dataObj.typeObject.id,
        landId: item.id,
        sourceId: state.sourceId,
      },
    });
  };
  const onAddLand = () => {
    router.push({
      path: "/baseManage/operationLand",
      query: {
        typeId: state.dataObj.typeObject.id,
        sourceId: state.sourceId,
      },
    });
  };
  const onDeleteTrail = (item: any) => {
    Dialog.alert({
      title: "提示",
      message: "确定删除该数据？",
      showCancelButton: true,
    }).then(() => {
      deleteTrailData(item.id);
    });
  };
  const onEditTrail = (item: any) => {
    router.push({
      name: "OperationBase",
      params: {
        sourceId: state.sourceId,
      },
      query: {
        item: JSON.stringify(item),
      },
    });
  };
  const onAddTrail = () => {
    router.push("/baseManage/operationBase/" + state.sourceId);
  };
  const onSwipeChange = (e: any) => {
    // console.log(e, "eee");
  };
  const onTaskLoad = () => {
    task.search(null);
  };
  const onRecordLoad = () => {
    record.search(null);
  };
  const onLandLoad = () => {
    land.search(null);
  };
  const onPatrolLoad = () => {
    trail.search(null);
  };
  return {
    toResource,
    onPatrolLoad,
    onLandLoad,
    onRecordLoad,
    onSwipeChange,
    onTaskLoad,
    onEditTrail,
    onEditLand,
    onAddTrail,
    onDeleteTrail,
    onDelFarming,
    onAddLand,
    onStartChange,
    onLandChange,
    onEditFarming,
    onEndChange,
    onShowDetail,
    onDeleteLand,
    onClickAddRecord,
    onTaskLandChange,
    onCall,
    onRecord,
    onClickVideo,
    onClickImage,
    onTaskStatusChange,
    onIgnore,
  };
};
